import { FieldType } from 'Component/Field/Field.config';
import { ValidationInputType } from 'Util/Validator/Config';

export const jewelrytype = [{ id: 1, name: "Ring" }, { id: 2, name: "Necklace" }, { id: 3, name: "Pendant" }, { id: 4, name: "Braclate" }];

export const CustomJewelryForm = () => [
    {
        type: FieldType.TEXT,
        label: 'Name',
        attr: {
            name: 'name',
            placeholder: 'Your name',
        },
        addRequiredTag: true,
        validateOn: ['onChange'],
        validationRule: {
            isRequired: true,
        },
    },
    {
        type: FieldType.EMAIL,
        label: 'Email',
        attr: {
            name: 'email',
            placeholder: 'Your email',
        },
        addRequiredTag: true,
        validateOn: ['onChange'],
        validationRule: {
            inputType: ValidationInputType.EMAIL,
            isRequired: true,
        },
    },
    {
        type: FieldType.TEXT,
        label: 'Phone number',
        attr: {
            name: 'telephone',
            placeholder: 'Phone number',
        },
        validateOn: ['onChange'],
        validationRule: {
            inputType: ValidationInputType.PHONE,
        },
    },
    {
        type: FieldType.SELECT,
        label: 'Custom jewelry Type',
        options: jewelrytype.map(({ id, name }) => ({ id, label: name, value: id })),
        attr: {
            name: 'jewelrytype',
            selectPlaceholder: 'Select Type',
        },
        addRequiredTag: true,
        validateOn: ['onChange'],
        validationRule: {
            isRequired: true,
        },
    },
    {
        type: FieldType.TEXTAREA,
        label: 'description of inquiry',
        subLabel: "Please include any/all details which you think may help our team understand your needs.",
        attr: {
            name: 'message',
            placeholder: 'Type your description here...',
        },
        addRequiredTag: true,
        validateOn: ['onChange'],
        validationRule: {
            isRequired: true,
        },
    },
    {
        type: FieldType.FILE,
        label: 'Upload image',
        subLabel: "Share images to help us understand your custom design needs.",
        attr: {
            name: 'image',
            placeholder: 'Drag and drop files here or Choose files',
            accept: ".png,.jpg,.jpeg"
        },
        addRequiredTag: false,
        validateOn: ['onChange'],
        validationRule: {
            isRequired: false,
        },
    },
];

export default CustomJewelryForm;
